import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import BookAppointment from "@/pages/BookAppointment";
import ServiceRequest from "@/pages/ServiceRequest";
import PublicCalendar from "@/pages/PublicCalendar";
import AdminAuth from "@/pages/AdminAuth";
import AdminDashboard from "@/pages/AdminDashboard";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import Blog from "@/pages/Blog";
import Shop from "@/pages/Shop";
import GrantAppreciation from "@/pages/GrantAppreciation";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/grant-appreciation" element={<GrantAppreciation />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/book" element={<BookAppointment />} />
            <Route path="/calendar" element={<PublicCalendar />} />
            <Route path="/request-service" element={<ServiceRequest />} />
            <Route path="/admin" element={<AdminAuth />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
